import {UserRepository} from '../repository/UserRepository';
import {AppError, ErrorType} from '../../../Data/config/AppError';

export class DeleteUserUseCase {
  private readonly userRepository: UserRepository;

  constructor (userRepository: UserRepository) {
    this.userRepository = userRepository;
  }

  async execute (userId: number, currentUserId?: number): Promise<void> {
    // Validate user ID
    if (!userId || userId < 1) {
      throw new AppError('معرف المستخدم صحيح مطلوب', ErrorType.VALIDATION);
    }

    // Prevent self-deletion
    if (currentUserId && userId === currentUserId) {
      throw new AppError('لا يمكن حذف حسابك الخاص', ErrorType.VALIDATION);
    }

    try {
      // Delete the user
      await this.userRepository.deleteUser(userId);
    } catch (error) {
      // Don't handle error here - just throw it so it can be handled at the component level
      if (error instanceof AppError) {
        throw error;
      }
      throw AppError.fromApiError(error);
    }
  }
}
